var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1040,
    height: 428,
    viewBox: "0 0 1040 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_2158_12329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1342.57 510.257C1342.57 510.257 986.942 176.539 864.335 166.35C673.769 150.646 749.761 404.332 817.824 457.626C584.55 274.674 301.572 99.9121 188.181 165.25C76.4212 229.575 251.056 364.351 251.056 364.351C473.988 320.452 775.078 631.695 832.247 669.196C882.862 702.398 962.945 682.476 985.767 648.759C1037.39 572.481 989.996 451.508 958.532 388.346C957.244 386.218 956.766 383.711 957.183 381.269C957.6 378.828 958.885 376.612 960.809 375.018C962.733 373.424 965.17 372.554 967.686 372.566C970.201 372.577 972.63 373.468 974.54 375.08C1024.14 410.452 1123.2 479.201 1282.61 581.735C1357.78 630.064 1399.15 567.144 1342.53 510.053",
    fill: "#6C06F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.57 510.257C1342.57 510.257 986.942 176.539 864.335 166.35C673.769 150.646 749.761 404.332 817.824 457.626C584.55 274.674 301.572 99.9121 188.181 165.25C76.4212 229.575 251.056 364.351 251.056 364.351C473.988 320.452 775.078 631.695 832.247 669.196C882.862 702.398 962.945 682.476 985.767 648.759C1037.39 572.481 989.996 451.508 958.532 388.346C957.244 386.218 956.766 383.711 957.183 381.269C957.6 378.828 958.885 376.612 960.809 375.018C962.733 373.424 965.17 372.554 967.686 372.566C970.201 372.577 972.63 373.468 974.54 375.08C1024.14 410.452 1123.2 479.201 1282.61 581.735C1357.78 630.064 1399.15 567.145 1342.53 510.053",
    stroke: "url(#paint0_linear_2158_12329)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2158_12329",
    x: 0.326172,
    y: 0.765137,
    width: 1519.06,
    height: 835.968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_2158_12329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2158_12329",
    x1: 1245.4,
    y1: -48.1484,
    x2: 152.708,
    y2: 205.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.31187e551da53e34b5a95fe1605abf03.svg";
export { ForwardRef as ReactComponent };